// VERSÃO 16.0 ELITE - MEDIA ENGINE (BATCH PROTOCOL ENABLED)
import React from 'react';
import { 
    FiUpload, FiTrash2, FiDownload, FiCamera, 
    FiImage, FiLayers, FiEye, FiAlertTriangle 
} from 'react-icons/fi';
import { toast } from 'react-toastify';

function ImageUploader({ fieldName, label, icon: Icon = FiImage, files = [], onFileChange, onRemoveImage }) {
    
    const handleDownload = (file) => {
        const url = typeof file === 'string' ? file : URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = `MOS-GOLD-ASSET-${Date.now()}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleView = (file) => {
        const url = typeof file === 'string' ? file : URL.createObjectURL(file);
        window.open(url, '_blank');
    };

    const resolveUrl = (file) => (typeof file === 'string' ? file : URL.createObjectURL(file));

    // 🛡️ PROTOCOLO DE CARGA TÁTICA: Agora aceita muitos, mas avisa sobre os lotes
    const handleFilesWithLimit = (e) => {
        const selectedFiles = Array.from(e.target.files);
        if (selectedFiles.length > 150) {
            toast.error("🚨 BLOQUEIO: Máximo de 150 arquivos por setor.");
            return;
        }
        if (selectedFiles.length > 5) {
            toast.info(`📦 MODO MALOTE: ${selectedFiles.length} arquivos serão fatiados em lotes de 05.`);
        }
        onFileChange(e);
    };

    return (
        <div className="w-full p-8 rounded-[2.5rem] border border-[var(--border-color)] transition-all shadow-xl bg-[var(--bg-card)]">
            <div className="flex justify-between items-center mb-8 px-2">
                <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-2xl bg-[var(--bg-main)] border border-[var(--border-color)] flex items-center justify-center text-accent shadow-inner">
                        <Icon size={20} />
                    </div>
                    <div>
                        <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-auto leading-none">{label}</h4>
                        <p className="text-[7px] font-bold uppercase tracking-widest text-accent mt-1">Status: Prontidão</p>
                    </div>
                </div>
                <div className="px-4 py-1.5 rounded-full text-[9px] font-black uppercase bg-black/20 border border-white/5 text-auto">
                    {files.length.toString().padStart(2, '0')} <span className="opacity-30 ml-1">Arquivos</span>
                </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
                <label className="lg:w-48 h-48 flex flex-col items-center justify-center border-2 border-dashed border-[var(--border-color)] rounded-[2.5rem] cursor-pointer transition-all group hover:border-accent hover:bg-accent/5 shrink-0">
                    <FiUpload className="text-2xl text-accent mb-2 group-hover:scale-110 transition-transform" />
                    <span className="text-[8px] font-black uppercase tracking-[0.2em] text-auto opacity-40 text-center px-4">
                        Injetar Mídia <br/> (Protocolo Malote)
                    </span>
                    <input type="file" className="hidden" onChange={handleFilesWithLimit} name={fieldName} multiple accept="image/*" />
                </label>

                <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
                    {files.map((file, index) => (
                        <div key={index} className="relative aspect-square rounded-2xl overflow-hidden border border-[var(--border-color)] group/item shadow-lg bg-black">
                            <img src={resolveUrl(file)} className="h-full w-full object-cover opacity-80 group-hover/item:opacity-100 transition-all duration-500" alt="Asset" />
                            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm opacity-0 group-hover/item:opacity-100 transition-all duration-300 flex flex-col items-center justify-center gap-2">
                                <div className="grid grid-cols-2 gap-2 p-2">
                                    <button type="button" onClick={() => handleView(file)} className="p-2.5 bg-white/10 hover:bg-accent hover:text-black rounded-lg text-white transition-all shadow-xl"><FiEye size={16} /></button>
                                    <button type="button" onClick={() => handleDownload(file)} className="p-2.5 bg-white/10 hover:bg-green-500 rounded-lg text-white transition-all shadow-xl"><FiDownload size={16} /></button>
                                    <button type="button" onClick={() => onRemoveImage(fieldName, index, file)} className="p-2.5 bg-red-600/20 hover:bg-red-600 rounded-lg text-red-500 hover:text-white transition-all shadow-xl"><FiTrash2 size={16} /></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default function EtapaAcervoDigital({ formData, handleFileChange, removeImage }) {
    return (
        <div className="w-full space-y-10 animate-in fade-in zoom-in-95 duration-700">
            <div className="flex items-center gap-6 mb-12 border-b border-auto pb-8">
                <div className="relative">
                    <div className="w-16 h-16 rounded-3xl bg-accent/10 border border-accent/20 flex items-center justify-center text-accent shadow-2xl">
                        <FiCamera size={32} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-7 h-7 bg-accent text-black rounded-full flex items-center justify-center font-black text-[12px] border-2 border-[var(--bg-main)] shadow-lg">03</div>
                </div>
                <div>
                    <h2 className="text-3xl font-black uppercase tracking-tighter leading-none">Acervo Digital <span className="text-accent">Elite</span></h2>
                    <p className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40 mt-2">Sincronização por Malotes Ativa (Lotes de 05)</p>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-10">
                <ImageUploader fieldName="imagensDestaque" label="Imagem plano principal" icon={FiCamera} files={formData.imagensDestaque || []} onFileChange={handleFileChange} onRemoveImage={removeImage} />
                <ImageUploader fieldName="imagensQuartos" label="Beneficios" icon={FiLayers} files={formData.imagensQuartos || []} onFileChange={handleFileChange} onRemoveImage={removeImage} />
                <ImageUploader fieldName="imagensBanheiros" label="Como funciona" icon={FiLayers} files={formData.imagensBanheiros || []} onFileChange={handleFileChange} onRemoveImage={removeImage} />
                <ImageUploader fieldName="imagensOutros" label="Status de pedido online" icon={FiImage} files={formData.imagensOutros || []} onFileChange={handleFileChange} onRemoveImage={removeImage} />
            </div>

            <div className="flex items-center justify-center gap-4 p-6 rounded-2xl border border-dashed border-accent/20 bg-accent/5 opacity-60">
                <FiAlertTriangle className="text-accent" size={18} />
                <p className="text-[9px] font-black uppercase tracking-[0.3em] text-accent text-center">
                    SISTEMA DE ALTA CAPACIDADE: O UPLOAD SERÁ DIVIDIDO AUTOMATICAMENTE PARA GARANTIR A INTEGRIDADE DO ATIVO.
                </p>
            </div>
        </div>
    );
}